export default __webpack_public_path__ + "static/therapy1-edd158fc46ecc89de9cb341379ecb881.webp";